import { render, staticRenderFns } from "./form-queries-comment-form.vue?vue&type=template&id=739c6b32&scoped=true&"
import script from "./form-queries-comment-form.vue?vue&type=script&lang=js&"
export * from "./form-queries-comment-form.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-comment-form.vue?vue&type=style&index=0&id=739c6b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c6b32",
  null
  
)

component.options.__file = "form-queries-comment-form.vue"
export default component.exports